import {
    CONNECTION_LIST_SEARCH_TERM,
    ISetConnectionIdAction,
    ISetConnectionListPageAction,
    ISearchConnectionListAction,
    SET_CONNECTION_ID,
    SET_CONNECTION_LIST_PAGE,
} from './types/connection.actions.types';

export const setConnectionIdAction = (connectionId: string): ISetConnectionIdAction => ({
    type: SET_CONNECTION_ID,
    connectionId,
});

export const setConnectionListPageAction = (page: number): ISetConnectionListPageAction => ({
    type: SET_CONNECTION_LIST_PAGE,
    payload: page,
});

export const setConnectionListSearchTermAction = (searchTerm: string): ISearchConnectionListAction => ({
    type: CONNECTION_LIST_SEARCH_TERM,
    searchTerm,
});
